import {useEffect,useState,useLayoutEffect} from 'react'
import {Box,Typography,Button,Grid,Paper, Container,IconButton,CircularProgress} from '@mui/material'
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import {useNavigate} from 'react-router-dom'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Snackbar from '@mui/material/Snackbar'
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import end_test from '../Redux/reducers/end_test';
import TrainQuestionView from '../Components/TrainQuestionView';
import { ArrowBack, GraphicEqOutlined, Speaker } from '@mui/icons-material';
import start_train_test from '../Redux/reducers/start_train_test';
import send_train_test from '../Redux/reducers/send_train_test';
import FrontCamera from '../Components/FrontCamera'
import NoteDialog from '../Components/NoteDialog';

const StartBox = styled(Box, {
})(({ theme}) => ({
	transition: theme.transitions.create('width', {
	easing: theme.transitions.easing.sharp,
	duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
	width: 7,
	backgroundColor: '#000000'
},
'&::-webkit-scrollbar-thumb': {
	backgroundColor: '#ffffff',
	borderRadius: 5
},
background:"#100101",
minHeight:300,
justifyContent:"flex-start",
alignItems:"center",
borderRadius:10,
minWidth:400,
maxWidth:"70%"
})
);

const ContainerBox = styled(Box, {
	})(({ theme}) => ({
		transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowY: 'auto',
	overflowX: 'hidden',
	'&::-webkit-scrollbar': {
		width: 10,
		backgroundColor: '#000000'
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#ffffff',
		borderRadius: 10
	},
	minHeight:250,
	justifyContent:"flex-start",
	alignItems:"center",
	borderRadius:10,
	maxHeight:500
	})
);

const TrainTest = ()=>{

	const [open,setOpen] = useState(false)
	const [isPaused,setIsPaused] = useState(true)
	const [message,setMessage] = useState('')
	const navigate = useNavigate()
	const theme = useTheme()
	const [count,setCount] = useState(0)
	const dispatch = useDispatch()
	const [response,setResponse] = useState("")
	const [question,setQuestion] = useState({})
	const [hasStarted,setHasStarted] = useState(false)
	const mode = useSelector(state => state?.theme?.mode);
	const [submitting,setSubmitting] = useState(false)
	const [disqualify,setDisqualify] = useState(false)
	const user = useSelector(state => state?.pass.user);
	const userAuth = useSelector(state => state?.auth.user);
    const data = useSelector(state => state?.pass.test);
	const [div,setDiv] = useState(parseInt((data?.time*60)/data?.questions))
	const [score,setScore] = useState(0)
	const [hasEnded,setHasEnded] = useState(false)
	const [showModal,setShowModal] = useState(false)
	const [time,setTime] = useState(data?.time*60)
    const [history,setHistory] = useState([])

async function handleEnd (){
	try{
		const test_data = {
			test:data,
			email:user?.email,
			token:user?.accessToken
		}

		console.log("you have been disqualify...!")

	}catch(err){
		console.log(err)
	}
}

async function handleStart (){
	try{
		const test_data = {
			test:data,
            history:history,
			user:{
                email:user?.email,
                first_name:user?.first_name,
                last_name:user?.last_name
            }
		}

		await start_train_test(test_data,userAuth?.accessToken,setOpen,setMessage,setSubmitting,setHasStarted,setQuestion,setIsPaused,setDiv,setTime,setHistory)
	
	}catch(err){
		console.log(err)
	}
}
async function handleChat (){
	try{
	
		if (!hasEnded) {
	
		const test_data = {
			test:data,
			message:response || "xxxxxxxxxxxxxxx",
            history:history,
            user:{
                email:user?.email,
                first_name:user?.first_name,
                last_name:user?.last_name
            }
		}
	
		await send_train_test(test_data,userAuth?.accessToken,setOpen,setMessage,setSubmitting,setQuestion,setResponse,setHasEnded,setCount,setIsPaused,setDiv,setHistory,setScore)
		
		} else {
            setIsPaused(true)
            setTime(0)
            setDiv(0)
            navigate("/createTrain")
            setHasStarted(false)
            setCount(0)
		}
	}catch(err){
		console.log(err)
	}
}
		
async function sendChat(message){
	try{
	
		if (!hasEnded) {
		
			const test_data = {
			    test:data,
                message:message || "xxxxxxxxxxxxxxx",
                history:history,
                user:{
                    email:user?.email,
                    first_name:user?.first_name,
                    last_name:user?.last_name
                }
			}

		await send_train_test(test_data,userAuth?.accessToken,setOpen,setMessage,setSubmitting,setQuestion,setResponse,setHasEnded,setCount,setIsPaused,setDiv,setHistory,setScore)
		
		}else{
			setTime(0)
			setDiv(0)
			setIsPaused(true)
		}
	}catch(err){
		console.log(err)
	}
}

useLayoutEffect(() => {
if (!isPaused) {
	if (time > 0) {
	const interval = setInterval(() => {
		if (time > 0) {
		setTime((prevTime) => prevTime - 1);
		if (div > 0) {
			setDiv((prevTime) => prevTime - 1);
		}else{
			setDiv(0)
			setIsPaused(true)
			sendChat()
		}
		}else{
			setTime(0);
			setIsPaused(true)
		}
	}, 1000);

	return () => clearInterval(interval); 
	}
}
}, [time,div,isPaused]);

const formatTime = (seconds) => {
	const hours = Math.floor(seconds / 3600);
	const minutes = Math.floor((seconds % 3600) / 60);
	const remainingSeconds = seconds % 60;
return `${hours.toString().padStart(2, '0')}:${minutes
	.toString()
	.padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
}; 

	return(
	 <Grid container>
		<Grid item xs={12} sm={12} md={12} style={{height:70}}>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{width:"80%",textAlign:"left"}}>
			{
				hasStarted ?
				<Box m={2} sx={{background:"#100101",minWidth:"60%",maxWidth:"70%",marginLeft:{sm:5,xs:5,md:17}}} display="flex" flexDirection="row" justifyContent="center" alignItems="flex-start">
					<FrontCamera handleEnd={handleEnd} /> 
					<Box mt={2}>
						<Header>
							<Breadcrumbs aria-label="breadcrumb">
								<Typography sx={{fontSize:12,color:"gray"}}>Dashboard</Typography>
								<Typography sx={{fontSize:12,color:"gray"}}>Take Assessment</Typography>
							</Breadcrumbs>			
						</Header>
						<Snackbar 
							anchorOrigin={{
								vertical: 'top',
								horizontal: 'left',
							}} 
							message={message} 
							onClose={()=>{setOpen(false)}}
							open={open} 
							autoHideDuration={2000}
						/>
						<ContainerBox sx={{p:2}}>
							<Box ml={2}>
								<Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="80%">
									<Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
										Train yourself
									</Typography>	
									<IconButton onClick={(e)=>{
										e?.preventDefault()
										navigate("/createTrain")
									}}>
										<ArrowBack fontSize='small' sx={{color:"gold"}}/>
									</IconButton>					
								</Box>
								<TrainQuestionView score={score} currentQuestion={count+1} hasEnded={hasEnded} totalQuestions={data?.questions} submitting={submitting} message={response} setMessage={setResponse} time={formatTime(time)} subTime={formatTime(div)} handleSend={handleChat} questions={data?.questions} count={count} content={question} title={data?.name} />
							</Box>		
						</ContainerBox>
					</Box>				
				</Box>

			:
                <StartBox sx={{marginLeft:{sm:5,xs:5,md:17},p:2}}>
                    <Header>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Typography color="text.primary" sx={{fontSize:12}}>Dashboard</Typography>
                            <Typography color="text.primary" sx={{fontSize:12}}>Take Assessment</Typography>
                        </Breadcrumbs>			
                    </Header>
                    <Snackbar 
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }} 
                        message={message} 
                        onClose={()=>{setOpen(false)}}
                        open={open} 
                        autoHideDuration={5000}
                    />
                    <Box ml={2}>
                        <Typography  mb={2} mt={2} ml={4} variant="h6" color="gold" fontWeight={500} sx={{fontFamily:"dinofans"}}>
                            Train yourself
                        </Typography>
						<ItemView title="Title" content={data?.name}/>
                        <ItemView title="Description" content={data?.description}/>
                        <Box ml={5} sx={{display:"flex",flexDirection:{xs:"column",md:"row"},justifyContent:"space-evenly",width:{xs:"70%",md:"40%"},alignItems:"flex-start",marginBottom:3}}>
                            <Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                                <IconButton>
                                    <Speaker style={{color:"gray"}}/>
                                </IconButton>
                                <Typography color="white" fontSize={14} width={100}>
                                    {data?.language}
                                </Typography>
                            </Box>
                            <Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                                <IconButton>
                                    <GraphicEqOutlined style={{color:"gray"}}/>
                                </IconButton>
                                <Typography color="white" fontSize={14} width={100}>
                                    {data?.level}
                                </Typography>
                            </Box>
                            <Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
                                <IconButton>
                                    <CalendarMonthIcon style={{color:"gray"}}/>
                                </IconButton>
                                <Typography color="white" fontSize={14} width={100}>
                                    {data?.time} min
                                </Typography>
                            </Box>
                        </Box>
                        <Button onClick={ async (e)=>{
                            e?.preventDefault()
                            setShowModal(true)
                        }} sx={{backgroundColor:"gold",color:"black",marginLeft:{xs:0,md:5},marginRight:{xs:0,md:5},fontSize:{xs:10,md:12},height:40,width:{xs:120,md:200},fontFamily:"dinofans"}} variant="contained">
                            {
                                submitting ? 
                                    <CircularProgress size={20} sx={{color:"black"}}/>
                                :
                                "Start test"
                            }
                        </Button>
                    </Box>			
               </StartBox>
			}
			<NoteDialog setVisible={setShowModal} visible={showModal} handleClick={handleStart}/>
		</Grid>
		<Grid item xs={12} sm={12} md={12} style={{height:40}}>
		</Grid>
	 </Grid>

	)

	}

	export default TrainTest